import React from 'react'
import { GridContainer, GridItem, Image, Item, List } from './Infographics.styles'

/**
 * The InfoAgilePurchaseTradedProvider's component.
 */
const InfoAgilePurchaseTradedProviders = () => (
  <GridContainer padding="0 0 8px" spacing={2}>
    <GridItem sm={6} xs={12}>
      <Image alt="Imagen ayuda" src="/assets/images/accordion-examples/Ejemplo-InfoAgilePurchaseTradedProviders.svg" />
    </GridItem>
    <GridItem sm={6} xs={12}>
      <List>
        <Item>Selecciona el año a consultar.</Item>
        <Item>Selecciona la región a consultar.</Item>
        <Item>Selecciona el indicador a visualizar.</Item>
        <Item>Corresponde a la Razón social y RUT del proveedor.</Item>
        <Item>Información del monto transado o número de órdenes de compra.</Item>
        <Item>Indica al monto transado u ordenes de compra por cada proveedor.</Item>
      </List>
    </GridItem>
  </GridContainer>
)

export default InfoAgilePurchaseTradedProviders
